/* SHAPE OPTION FILTER LOGIC */
function updateShapeOptions() {
  //update if options to include if has class?
	if ( ~window.location.href.indexOf("punches") ) {
    	// Show shape options menu
        $(".collection-sidebar__group--1572014462203").show();
      
      	//$(".collection-sidebar .collection-sidebar__group--1572014462203 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
          // $(".collection-sidebar .collection-sidebar__group--1572014462203 .collapsible-trigger").trigger("click");
          if ( ~window.location.href.indexOf("+f9")
             || ~window.location.href.indexOf("+f12")
             || ~window.location.href.indexOf("+f13")
             || ~window.location.href.indexOf("+f16") 
             || ~window.location.href.indexOf("+f20") 
             || ~window.location.href.indexOf("+f20-gxl78") 
             || ~window.location.href.indexOf("+f20-gxl97") 
             || ~window.location.href.indexOf("+f26") 
             || ~window.location.href.indexOf("+f26s") 
             || ~window.location.href.indexOf("+f272") 
             || ~window.location.href.indexOf("+f770") 
             || ~window.location.href.indexOf("+h1") 
             || ~window.location.href.indexOf("+h2")
             || ~window.location.href.indexOf("+sr20k")
             || ~window.location.href.indexOf("+sun30")
             || ~window.location.href.indexOf("+sun40")
             || ~window.location.href.indexOf("+12mm") ) {
              setTimeout(function(){ 
                // $(".collection-sidebar .collection-sidebar__group--054dae33-ae71-44d3-80f3-204ede1032a3 .collapsible-trigger").trigger("click");
              }, 360); 
          }
        }, 500);  
      
       	// Activate checkbox for punches (if loaded from menu)
       	$(".collection-sidebar__group--1572013439404 .tag-list li:nth-child(1)").addClass("tag--active");
    } 
	  
  	if (  ~window.location.href.indexOf("dies") ) {
      	// Show shape options menu
        $(".collection-sidebar__group--1572014462203").show();
      
      	//$(".collection-sidebar .collection-sidebar__group--1572014462203 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
          // $(".collection-sidebar .collection-sidebar__group--1572014462203 .collapsible-trigger").trigger("click");
          if ( ~window.location.href.indexOf("+c89")
             || ~window.location.href.indexOf("+f43")
             || ~window.location.href.indexOf("+f51")
             || ~window.location.href.indexOf("+f55") 
             || ~window.location.href.indexOf("+f59") 
             || ~window.location.href.indexOf("+f62") 
             || ~window.location.href.indexOf("+f62s") 
             || ~window.location.href.indexOf("+f155") 
             || ~window.location.href.indexOf("+h1") 
             || ~window.location.href.indexOf("+h2")
             || ~window.location.href.indexOf("+sun45")
             || ~window.location.href.indexOf("+sun60")
             || ~window.location.href.indexOf("+35mm") ) {
              setTimeout(function(){ 
                // $(".collection-sidebar .collection-sidebar__group--c8d9e012-1f55-4c00-8e6f-f31de31d7780 .collapsible-trigger").trigger("click");
              }, 360); 
          }
        }, 500); 
      
       	// Activate checkbox for dies (if loaded from menu)
       	$(".collection-sidebar__group--1572013439404 .tag-list li:nth-child(2)").addClass("tag--active");
	}

	// Clear Shape Options if Punches or Dies not selected
  	if ( !~window.location.href.indexOf("dies") && !~window.location.href.indexOf("punches") ) {
      // List of all Shap Options to remove
      
     	$(".collection-sidebar__group--1572014462203 .tag-list li.tag--active a").trigger("click");
  	}
}

/* Punch Figure Number FILTER LOGIC */
function updatePunchFigureNumberOptions() {
  //update if options to include if has class?
	if ( ~window.location.href.indexOf("punches") ) {
    	// Show shape options menu
        $(".collection-sidebar__group--054dae33-ae71-44d3-80f3-204ede1032a3").show();
      
        setTimeout(function(){ 
          // $(".collection-sidebar .collection-sidebar__group--054dae33-ae71-44d3-80f3-204ede1032a3 .collapsible-trigger").trigger("click");
        }, 500);
    } 

	// Clear Shape Options if Punches or Dies not selected
  	if ( !~window.location.href.indexOf("punches") ) {
      // List of all Shap Options to remove
      if ( !~window.location.href.indexOf("punch-die-sets") ) {
     	$(".collection-sidebar__group--054dae33-ae71-44d3-80f3-204ede1032a3 .tag-list li.tag--active a").trigger("click");
      }
  	}
}

/* Die Figure Number FILTER LOGIC */
function updateDieFigureNumberOptions() {
  //update if options to include if has class?
	if ( ~window.location.href.indexOf("dies") ) {
    	// Show shape options menu
        $(".collection-sidebar__group--c8d9e012-1f55-4c00-8e6f-f31de31d7780").show();
      
        setTimeout(function(){ 
          // $(".collection-sidebar .collection-sidebar__group--c8d9e012-1f55-4c00-8e6f-f31de31d7780 .collapsible-trigger").trigger("click");
        }, 500);
    } 

	// Clear Shape Options if Punches or Dies not selected
  	if ( !~window.location.href.indexOf("dies") ) {
      // List of all Shap Options to remove
      if ( !~window.location.href.indexOf("punch-die-sets") ) {
     	$(".collection-sidebar__group--c8d9e012-1f55-4c00-8e6f-f31de31d7780 .tag-list li.tag--active a").trigger("click");
      }
  	}
}

/* Punch & Die Figure Number FILTER LOGIC */
function updatePunchDieFigureNumberOptions() {
  //update if options to include if has class?
	if ( ~window.location.href.indexOf("punch-die-sets") ) {
    	// Show shape options menu
      	$(".collection-sidebar__group--054dae33-ae71-44d3-80f3-204ede1032a3").show();
        $(".collection-sidebar__group--c8d9e012-1f55-4c00-8e6f-f31de31d7780").show();
      setTimeout(function(){ 
        if ( ~window.location.href.indexOf("+f9")
            || ~window.location.href.indexOf("+f13")
            || ~window.location.href.indexOf("+f16") 
            || ~window.location.href.indexOf("+f20") 
            || ~window.location.href.indexOf("+f26")  
            || ~window.location.href.indexOf("+f770")
            || ~window.location.href.indexOf("+sr20k")
            || ~window.location.href.indexOf("+sun30") ) {
          // $(".collection-sidebar .collection-sidebar__group--054dae33-ae71-44d3-80f3-204ede1032a3 .collapsible-trigger").trigger("click");
        }
        if ( ~window.location.href.indexOf("+f43")
            || ~window.location.href.indexOf("+f51")
            || ~window.location.href.indexOf("+f55") 
            || ~window.location.href.indexOf("+f59") 
            || ~window.location.href.indexOf("+f62")  
            || ~window.location.href.indexOf("+f155") 
            // || ~window.location.href.indexOf("+f740")
            || ~window.location.href.indexOf("+sun45") ) {
          // $(".collection-sidebar .collection-sidebar__group--c8d9e012-1f55-4c00-8e6f-f31de31d7780 .collapsible-trigger").trigger("click");
        }
      }, 500);
    } 

	// Clear Shape Options if Punches or Dies not selected
  	if ( !~window.location.href.indexOf("punch-die-sets") ) {
      // List of all Shap Options to remove
      if ( !~window.location.href.indexOf("punches") ) {
      	$(".collection-sidebar__group--054dae33-ae71-44d3-80f3-204ede1032a3 .tag-list li.tag--active a").trigger("click");
      }
      if ( !~window.location.href.indexOf("dies") ) {
     	$(".collection-sidebar__group--c8d9e012-1f55-4c00-8e6f-f31de31d7780 .tag-list li.tag--active a").trigger("click");
      }
  	}
}

/* SHEAR BLADE OPTION FILTER LOGIC */
function updateShearBladeOptions() {
  //update if options to include if has class?
	if ( ~window.location.href.indexOf("shear-blades") ) {
    	// Show shape options menu
        $(".collection-sidebar__group--1591729241071").show();
      
        setTimeout(function(){ 
          // $(".collection-sidebar .collection-sidebar__group--1591729241071 .collapsible-trigger").trigger("click");
        }, 500);  
      
       	// Activate checkbox for shear blades (if loaded from menu)
       	$(".collection-sidebar__group--1572013439404 .tag-list li:nth-child(3)").addClass("tag--active");
    } 

	// Clear Shape Options if Punches or Dies not selected
  	if ( !~window.location.href.indexOf("shear-blades") ) {
      // List of all Shap Options to remove
      
     	$(".collection-sidebar__group--1591729241071 .tag-list li.tag--active a").trigger("click");
  	}
}

/* SHEAR BLADE SETS OPTION FILTER LOGIC */
function updateShearBladeSetsOptions() {
  // Update if options to include if has class?
  if (~window.location.href.indexOf("shear-blade-sets")) {
    // Show shape options menu
    $(".collection-sidebar__group--4d0d0ea1-d177-4e20-aefa-27535716dcfc").show();

    setTimeout(function() {
      // $(".collection-sidebar .collection-sidebar__group--4d0d0ea1-d177-4e20-aefa-27535716dcfc .collapsible-trigger").trigger("click");
    }, 500);

    // Activate checkbox for shear blade sets (if loaded from menu)
    $(".collection-sidebar__group--1572013439404 .tag-list li:nth-child(3)").addClass("tag--active");
  }

  // Clear Shape Options if Punches or Dies not selected
  if (!~window.location.href.indexOf("shear-blade-sets")) {
    // List of all Shape Options to remove
    $(".collection-sidebar__group--4d0d0ea1-d177-4e20-aefa-27535716dcfc .tag-list li.tag--active a").trigger("click");
  }
}

/* FLAT BAR SHEAR BLADES FLAT BAR FILTER LOGIC */
function updateFlatBarOptions() {
  //update if options to include if has class?
	if (window.location.href.indexOf("flat-bar") !== -1) {
    	// Show flar bar options menu
        $(".collection-sidebar__group--tags_group_hBPm8g").show();
      
        setTimeout(function(){ 
          // $(".collection-sidebar .collection-sidebar__group--tags_group_hBPm8g .collapsible-trigger").trigger("click");
        }, 500);  
      
       	// Activate checkbox for shear blades (if loaded from menu)
       	$(".collection-sidebar__group--1572013439404 .tag-list li:nth-child(3)").addClass("tag--active");
    } 

	// Clear Shape Options if Punches or Dies not selected
  	if ( !~window.location.href.indexOf("shear-blades") ) {
      // List of all Shape Options to remove
      
     	$(".collection-sidebar__group--tags_group_hBPm8g .tag-list li.tag--active a").trigger("click");
  	}
}

/* NOTCHER SHEAR BLADES NOTCHER FILTER LOGIC */
function updateNotcherOptions() {
  //update if options to include if has class?
	if (window.location.href.indexOf("+notcher") !== -1) {
    	// Show notcher options menu
        $(".collection-sidebar__group--tags_group_yN3PWR").show();
      
        setTimeout(function(){ 
          // $(".collection-sidebar .collection-sidebar__group--tags_group_yN3PWR .collapsible-trigger").trigger("click");
        }, 500);  
      
       	// Activate checkbox for shear blades (if loaded from menu)
       	$(".collection-sidebar__group--1572013439404 .tag-list li:nth-child(3)").addClass("tag--active");
    } 

	// Clear Shape Options if Punches or Dies not selected
  	if ( !~window.location.href.indexOf("shear-blades") ) {
      // List of all Shap Options to remove
      
     	$(".collection-sidebar__group--tags_group_yN3PWR .tag-list li.tag--active a").trigger("click");
  	}
}

/* NOTCHER SHEAR BLADES ANGLE FILTER LOGIC */
function updateAngleOptions() {
  //update if options to include if has class?
	if (window.location.href.indexOf("+angle") !== -1) {
    	// Show notcher options menu
        $(".collection-sidebar__group--tags_group_N3FYTU").show();
      
        setTimeout(function(){ 
          // $(".collection-sidebar .collection-sidebar__group--tags_group_N3FYTU .collapsible-trigger").trigger("click");
        }, 500);  
      
       	// Activate checkbox for shear blades (if loaded from menu)
       	$(".collection-sidebar__group--1572013439404 .tag-list li:nth-child(3)").addClass("tag--active");
    } 

	// Clear Shape Options if Punches or Dies not selected
  	if ( !~window.location.href.indexOf("shear-blades") ) {
      // List of all Shap Options to remove
      
     	$(".collection-sidebar__group--tags_group_N3FYTU .tag-list li.tag--active a").trigger("click");
  	}
}

/* ACCESSORIES FILTER LOGIC */
function updateAccessoriesOptions() {
  //update if options to include if has class?
	if ( ~window.location.href.indexOf("accessories") ) {
    	// Show shape options menu
        $(".collection-sidebar__group--1591729277370").show();
      
        setTimeout(function(){ 
          // $(".collection-sidebar .collection-sidebar__group--1591729277370 .collapsible-trigger").trigger("click");
        }, 500);
      
       	// Activate checkbox for shear blades (if loaded from menu)
       	$(".collection-sidebar__group--1572013439404 .tag-list li:nth-child(4)").addClass("tag--active");
    } 

	// Clear Shape Options if Punches or Dies not selected
  	if ( !~window.location.href.indexOf("accessories") ) {
      // List of all Shap Options to remove
      
     	$(".collection-sidebar__group--1591729277370 .tag-list li.tag--active a").trigger("click");
  	}
}

/* Pipe Notch Units FILTER LOGIC */
function updatePipeNotchUnitsOptions() {
  //update if options to include if has class?
	if ( ~window.location.href.indexOf("pipe-notch-units") ) {
    	// Show shape options menu
        $(".collection-sidebar__group--5d6f3148-2016-414a-af09-77808ec1be2a").show();
      
      if ( !~window.location.href.indexOf("pipe-notch-tooling") ) {  
      	setTimeout(function(){ 
          // $(".collection-sidebar .collection-sidebar__group--5d6f3148-2016-414a-af09-77808ec1be2a .collapsible-trigger").trigger("click");
        }, 500);
      }
    } 

	// Clear Shape Options if Punches or Dies not selected
  	if ( !~window.location.href.indexOf("pipe-notch-units") ) {
      // List of all Shap Options to remove
      
     	$(".collection-sidebar__group--5d6f3148-2016-414a-af09-77808ec1be2a .tag-list li.tag--active a").trigger("click");
  	}
}

/* Pipe Notch Tooling FILTER LOGIC */
function updatePipeNotchToolingOptions() {
  //update if options to include if has class?
	if ( ~window.location.href.indexOf("pipe-notch-tooling") ) {
    	// Show shape options menu
        $(".collection-sidebar__group--e5ae6b14-2e02-4756-a3f2-fdd73127e46a").show();
      
        setTimeout(function(){ 
          // $(".collection-sidebar .collection-sidebar__group--e5ae6b14-2e02-4756-a3f2-fdd73127e46a .collapsible-trigger").trigger("click");
        }, 500);
    } 

	// Clear Shape Options if Punches or Dies not selected
  	if ( !~window.location.href.indexOf("pipe-notch-tooling") ) {
      // List of all Shap Options to remove
      
     	$(".collection-sidebar__group--e5ae6b14-2e02-4756-a3f2-fdd73127e46a .tag-list li.tag--active a").trigger("click");
  	}
}


/* Apparel FILTER LOGIC */
function updateApparelOptions() {
    //update if options to include if has class?
	if ( ~window.location.href.indexOf("apparel") ) {
    	// Show apparel options menu
        $(".collection-sidebar__group--56a03880-ae6b-4acb-8c87-ef40c0fbebf7").show();      
      
      	setTimeout(function(){ 
          // $(".collection-sidebar .collection-sidebar__group--56a03880-ae6b-4acb-8c87-ef40c0fbebf7 .collapsible-trigger").trigger("click");
        }, 500);      
    } 

	// Clear Apparel Options if Apparel is not selected
  	if ( !~window.location.href.indexOf("apparel") ) {
        // List of all Apparel Options to remove      
     	$(".collection-sidebar__group--56a03880-ae6b-4acb-8c87-ef40c0fbebf7 .tag-list li.tag--active a").trigger("click");
  	}
}

/* 36TC & 44TC Tooling FILTER LOGIC */
function update36TC44TCToolingOptions() {
    //update if options to include if has class?
	if ( ~window.location.href.indexOf("36tc-44tc-accessories") ) {
    	// Show 36TC & 44TC Tooling options menu
        $(".collection-sidebar__group--tags_group_KNCHGQ").show();
        // This is to hide the Accessories product filter
        $(".collection-sidebar__group--1591729277370").css("display", "none").attr("style", "display: none !important");
      
      	setTimeout(function(){ 
          // $(".collection-sidebar .collection-sidebar__group--tags_group_KNCHGQ .collapsible-trigger").trigger("click");
        }, 500);      
    } 

	// Clear 36TC & 44TC Tooling Options if 36TC & 44TC Tooling is not selected
  	if ( !~window.location.href.indexOf("36tc-44tc-accessories") ) {
        // List of all 36TC & 44TC Tooling Options to remove      
     	$(".collection-sidebar__group--tags_group_KNCHGQ .tag-list li.tag--active a").trigger("click");
  	}
}

/* Round Punch Size */

function updateRoundPunchSizeOptions() {
    const url = window.location.href.toLowerCase(); // normalize to lowercase

    const hasRoundPunch = url.includes("round") && url.includes("punches");

    // must also include one of these identifiers
    const hasIdentifier =
        url.includes("f16") ||
        url.includes("pir-dh") ||
        url.includes("cst219") ||
        url.includes("ap119");

    const isRoundPunchPage = hasRoundPunch && hasIdentifier;

    if (isRoundPunchPage) {
        // Show Round Round Punch Sizes options menu
        $(".collection-sidebar__group--tags_group_7fhBxQ").show();

        // Hide Accessories product filter
        $(".collection-sidebar__group--1591729277370")
            .css("display", "none")
            .attr("style", "display: none !important");

        setTimeout(function () {
            // Optional: expand collapsible or do something after delay
        }, 500);
    } else {
        // Clear Round Punch Sizes if Round Punch is not selected
        $(".collection-sidebar__group--tags_group_7fhBxQ .tag-list li.tag--active a").trigger("click");
    }
}

/* Round Die Size */
function updateRoundDieSizeOptions() {
    const url = window.location.href.toLowerCase(); // normalize to lowercase

    const hasRoundDie = url.includes("round") && url.includes("dies");

    // must also include one of these identifiers
    const hasIdentifier =
        url.includes("cst413") ||
        url.includes("pir-jb") ||
        url.includes("f55") ||
        url.includes("ap-313");

    const isAP313Page = hasRoundDie && hasIdentifier;

    if (isAP313Page) {
        $(".collection-sidebar__group--tags_group_gCAHbi").show();
        // Hide Accessories product filter
        $(".collection-sidebar__group--1591729277370")
            .css("display", "none")
            .attr("style", "display: none !important");

        setTimeout(function () {
            // Optional: expand collapsible or do something after delay
        }, 500);
    } else {
        $(".collection-sidebar__group--tags_group_gCAHbi .tag-list li.tag--active a").trigger("click");
    }
}


/* CUSTOM APPS LOGIC */
const filterCustomApps = (event) => {
  if (event.target.value == "all") {
    window.open(`/collections/custom-applications`,"_self");
  } else {
    window.open(`/collections/custom-applications/${event.target.value}`,"_self");
  }
}

const toggleModal = (modalId, num) => {
      document.getElementById(modalId+"-modal").classList.toggle("show-modal");
      if (document.getElementById(modalId+"-modal").classList.contains("show-modal")) {
        $(`#slider${num}`).slick('setPosition');
        $(`#sliderNav${num}`).slick('setPosition');
        $(`#slider${num}`).slick('refresh');
        $(`#sliderNav${num}`).slick('refresh');
        $(`#slider${num}.starting-slide`).addClass('slick-current');
        $(`#slider${num}.slick-current.slick-active`).removeClass('slick-current');
      }
      
      
        
        
      
  }

const formLinks = {
  'piranha-5-hole-unistrut': 'https://docs.google.com/forms/d/e/1FAIpQLSfVZn5_1K-6ylgayF467d09OmmPS4LRASv5tMRaQn1ohCsDuQ/viewform',
  'piranha-bending-attachment': 'https://docs.google.com/forms/d/e/1FAIpQLSeI2LE8G-1op2kEfsvifw7mwLcHxYhGJ9tXJc5xJOkdZijgkA/viewform',
  'channel-shear-blades': 'https://docs.google.com/forms/d/e/1FAIpQLSdCurwVM5GH4BNwAkZ6vQbdLZhOcqAUjwcHtH3D70LxxubPzg/viewform',
  'amada-marvel-punch-shear': 'https://docs.google.com/forms/d/e/1FAIpQLSdicgWVgh7kYlfu1pTnN5s6myPEz1e5YDjTQjqxFn999On3CQ/viewform',
  'mg2-coated-punch': 'https://docs.google.com/forms/d/e/1FAIpQLSeJuPOMGcymq_056DfWD9KjMv3kspMA8Fv6RQtNVJmL_MyCBw/viewform',
  'corner-radius': 'https://docs.google.com/forms/d/e/1FAIpQLSdCMjkAaicy_kRsQAeRPO44su6X9zsi1tLQMubweLw3Fnxw-w/viewform',
  'countersink': 'https://docs.google.com/forms/d/e/1FAIpQLScrboIiBlf8VArsUcASxm5sKI6vIju28pMRzzL1kns_JyhDZw/viewform',
  'double-step': 'https://docs.google.com/forms/d/e/1FAIpQLSfrGdv49i_1z3F_wmjCqX-xHLJZ9aak32BFuw6HXiF_aDegAQ/viewform',
  'dual-pipe-notch-tooling': 'https://docs.google.com/forms/d/e/1FAIpQLSfyD7nLz8tDdh8ha3zctqm6ZQRRjQe_YvBTyUNZMxIRh2j2IA/viewform',
  'embossing-punch': 'https://docs.google.com/forms/d/e/1FAIpQLSdS4jomlbQlAH6Pc_HZUtmU3QL8OtiEx_UnEOFPm2EPH3VCEQ/viewform',
  'gauge-line-flat': 'https://docs.google.com/forms/d/e/1FAIpQLScfY7T3QxMO2BG1u7L5Nv6wwoLZj7-70fNtqYVYbXXWmB6Gjw/viewform',
  'amada-marvel-guardrail-punch': 'https://docs.google.com/forms/d/e/1FAIpQLSeLTkGE6taKjkmN7pWViTcxQ829ArqZFVOZF62iScDCDRTSKw/viewform',
  'keyhole': 'https://docs.google.com/forms/d/e/1FAIpQLSfaKV6XMJBucnt3BXBV4xn5XABmQXVN_Ddf-ox2Wk0ziEoufA/viewform',
  'lattice-bar': 'https://docs.google.com/forms/d/e/1FAIpQLSf8DUvu20OPdkY44gELf_nKpWCfIyQYVLV22nJxkuKeyW2uAQ/viewform',
  'louver': 'https://docs.google.com/forms/d/e/1FAIpQLSeQ4nXvHP3p37jYJkLez7W7lmITXObAtDfkTTUGvp3xnRQCEQ/viewform',
  'offset-dies': 'https://docs.google.com/forms/d/e/1FAIpQLSdvoLPRmGFXs5KUwzxi6u-4P8QiBY0OPdx4nV3YLhacfoDYbQ/viewform',
  'picket': 'https://docs.google.com/forms/d/e/1FAIpQLSd7PlGFrfaF4y2H4u2YeHO3yatFZ-2TwPWdAVpwK9QeJZOwrQ/viewform',
  'pipe-notch-units': 'https://docs.google.com/forms/d/e/1FAIpQLSfX5fJrLZvtgexIbPAEggX0VeatOA2k6u4KA7H_eTodVnfibA/viewform',
  'piranha-punch-shear': 'https://docs.google.com/forms/d/e/1FAIpQLSdicgWVgh7kYlfu1pTnN5s6myPEz1e5YDjTQjqxFn999On3CQ/viewform',
  'ripping-punch': 'https://docs.google.com/forms/d/e/1FAIpQLSc1et6G33ybDUiK8JljiB2x3uB-oPyt4ymH1S4_iny5MyWGpA/viewform',
  'geka-round-pipe-mandrel': 'https://docs.google.com/forms/d/e/1FAIpQLSet7ZxQNuh64VYQOZ2VRXgMN7rjRoJ4ZnDou5SOtGGCuSZD0w/viewform',
  'spartan-square-tube-mandrel': 'https://docs.google.com/forms/d/e/1FAIpQLSfriaAQ-YO5Dirl9rY91a7LgM6ZBczQ7kM7pFKCXues5_iaBg/viewform',
  'star-punch': 'https://docs.google.com/forms/d/e/1FAIpQLSfBXT0azblFK5bwXfwCG-2e6FNHECxma7sBoK-zFJb0a4Pgbg/viewform',
  'w-a-whitney-cluster-punch': 'https://docs.google.com/forms/d/e/1FAIpQLSfKvTcSeOzjhV31ediPs3LHBzSjWIyrkQcx1z8vsQt-r1i91A/viewform',
  '5-hole-channel-strut-tooling': 'https://docs.google.com/forms/d/e/1FAIpQLSfVZn5_1K-6ylgayF467d09OmmPS4LRASv5tMRaQn1ohCsDuQ/viewform',
  'bending-attachment': 'https://docs.google.com/forms/d/e/1FAIpQLSeI2LE8G-1op2kEfsvifw7mwLcHxYhGJ9tXJc5xJOkdZijgkA/viewform',
  'cluster-punch': 'https://docs.google.com/forms/d/e/1FAIpQLSfKvTcSeOzjhV31ediPs3LHBzSjWIyrkQcx1z8vsQt-r1i91A/viewform',
  'double-punch-shear': 'https://docs.google.com/forms/d/e/1FAIpQLSdicgWVgh7kYlfu1pTnN5s6myPEz1e5YDjTQjqxFn999On3CQ/viewform',
  'double-step-punch': 'https://docs.google.com/forms/d/e/1FAIpQLSfrGdv49i_1z3F_wmjCqX-xHLJZ9aak32BFuw6HXiF_aDegAQ/viewform',
  'gauge-line-flat-punch': 'https://docs.google.com/forms/d/e/1FAIpQLScfY7T3QxMO2BG1u7L5Nv6wwoLZj7-70fNtqYVYbXXWmB6Gjw/viewform',
  'guardrail-punch': 'https://docs.google.com/forms/d/e/1FAIpQLSeLTkGE6taKjkmN7pWViTcxQ829ArqZFVOZF62iScDCDRTSKw/viewform',
  'pipe-notch-tooling': 'https://docs.google.com/forms/d/e/1FAIpQLSfX5fJrLZvtgexIbPAEggX0VeatOA2k6u4KA7H_eTodVnfibA/viewform',
  'round-pipe-mandrel': 'https://docs.google.com/forms/d/e/1FAIpQLSet7ZxQNuh64VYQOZ2VRXgMN7rjRoJ4ZnDou5SOtGGCuSZD0w/viewform',
  'single-punch-shear': 'https://docs.google.com/forms/d/e/1FAIpQLSdicgWVgh7kYlfu1pTnN5s6myPEz1e5YDjTQjqxFn999On3CQ/viewform',
  'square-tube-mandrel': 'https://docs.google.com/forms/d/e/1FAIpQLSfriaAQ-YO5Dirl9rY91a7LgM6ZBczQ7kM7pFKCXues5_iaBg/viewform'
}

const customAppQuote = (product) => {
  const url = formLinks[product];
  if (!url) {
    // No form mapped for this handle (usually a product rename). Never let the
    // button open about:blank - send the customer somewhere they can ask.
    window.location.href = '/pages/contact';
    return;
  }
  window.open(url);
}


/* MODEL OPTION FILTER LOGIC */
function updateModelOptions() {
	if ( ~window.location.href.indexOf("amada-marvel") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Marvel']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Marvel']").parent().show();
        }, 750);  
    }
  	if ( ~window.location.href.indexOf("baileigh") ) {
    	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Baileigh']").parent().addClass("tag--active");
       
      
        if ($('.collection-sidebar__group--1572014535551 .tag-list li a[title*="Baileigh"]').length) {
          // Show model options menu
          $('.collection-sidebar__group--1572014535551').show();

          // Show model options
          $(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
          setTimeout(function(){ 
            $('.collection-sidebar__group--1572014535551 .tag-list li a[title*="Baileigh"]').parent().show();
          }, 750);  
        }
    }
  	if ( ~window.location.href.indexOf("brobo") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Brobo']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Brobo']").parent().show();
        }, 750);  
    }
    if ( ~window.location.href.indexOf("buffalo") ) {
      	// Show model options menu
      	$(".collection-sidebar__group--1572014535551").show();
      
      	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Buffalo']").parent().addClass("tag--active");
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Buf']").parent().show();
        }, 750); 
    }
  
  	if ( ~window.location.href.indexOf("cayman") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Cayman']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Cayman']").parent().show();
        }, 750);  
    } 
  	if ( ~window.location.href.indexOf("clark") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Clark']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Clark']").parent().show();
        }, 750);  
    } 
  	if ( ~window.location.href.indexOf("cleveland-steel-tool") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='CST']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='CST']").parent().show();
        }, 750);  
    }   
  	if ( ~window.location.href.indexOf("controlled-automation") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Cont Auto']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Cont Auto']").parent().show();
        }, 750);  
    } 
  	if ( ~window.location.href.indexOf("davco-bully") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Davco/Bully']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Davco/Bully']").parent().show();
        }, 750);  
    }
  
  	if ( ~window.location.href.indexOf("durma") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Durma']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Durma']").parent().show();
        }, 750);  
    }   
  	if ( ~window.location.href.indexOf("edwards") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Edw']").parent().addClass("tag--active");
      	
      
      	// Show model options
     	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Edw']").parent().show();
        }, 750);   
      
    } 
  	if ( ~window.location.href.indexOf("enerpac") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Enerpac']").parent().addClass("tag--active");
      	
      
      	// Show model options
     	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Enerpac']").parent().show();
        }, 750);   
      
    } 
  	if ( ~window.location.href.indexOf("excel") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Excel']").parent().addClass("tag--active");
      	
      
      	// Show model options
     	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Excel']").parent().show();
        }, 750);   
      
    }
  	if ( ~window.location.href.indexOf("fabmaster") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Fab']").parent().addClass("tag--active");
      	
      
      	// Show model options
     	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Fab']").parent().show();
        }, 750);   
      
    }
  	if ( ~window.location.href.indexOf("falcon") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Falcon']").parent().addClass("tag--active");
      	
      
      	// Show model options
     	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Falcon']").parent().show();
        }, 750);   
      
    }  
  	if ( ~window.location.href.indexOf("ficep") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Ficep']").parent().addClass("tag--active");
      	
      
      	// Show model options
     	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Ficep']").parent().show();
        }, 750);   
    }  
  	if ( ~window.location.href.indexOf("franklin") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Franklin']").parent().addClass("tag--active");
      	
      
      	// Show model options
     	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Franklin']").parent().show();
        }, 750);   
      
    } 
  	if ( ~window.location.href.indexOf("gairu") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Gairu']").parent().addClass("tag--active");
      	
      
      	// Show model options
     	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      	setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Gairu']").parent().show();
        }, 750);   
      
    } 
  	if ( ~window.location.href.indexOf("geka") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Geka']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Geka']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("hawthorne") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Haw']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Haw']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("hendley-whittemore") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='H&W']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='H&W']").parent().show();
        }, 750);   
    }
    if ( ~window.location.href.indexOf("heller") ) {
      // Activate checkbox for controlled automation (if loaded from menu)
      $(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Heller']").parent().addClass("tag--active");

      if ($('.collection-sidebar__group--1572014535551 .tag-list li a[title*="Heller"]').length) {
        // Show model options menu
      	$('.collection-sidebar__group--1572014535551').show();
        
       	// Show model options
        $(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
          $('.collection-sidebar__group--1572014535551 .tag-list li a[title*="Heller"]').parent().show();
        }, 750);  
      }  
    }
    if ( ~window.location.href.indexOf("hill-acme") ) {
      // Show model options menu
      $(".collection-sidebar__group--1572014535551").show();
      // Activate checkbox for controlled automation (if loaded from menu)
      $(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Hill Acme']").parent().addClass("tag--active");


      // Show model options
      $(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
      setTimeout(function(){ 
        $(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Hill Acme']").parent().show();
      }, 750);   
    }  
  	if ( ~window.location.href.indexOf("hmi") ) {
    	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='HMI']").parent().addClass("tag--active");
      
      	if ($('.collection-sidebar__group--1572014535551 .tag-list li a[title*="HMI"]').length) {
          // Show model options menu
          $(".collection-sidebar__group--1572014535551").show();
          
          // Show model options
          $(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
          setTimeout(function(){ 
              $(".collection-sidebar__group--1572014535551 .tag-list li a[title*='HMI']").parent().show();
          }, 750);   
        }
    }
  	if ( ~window.location.href.indexOf("ironcrafter") ) {
    	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Ironcrafter']").parent().addClass("tag--active");
      	
      	if ($('.collection-sidebar__group--1572014535551 .tag-list li a[title*="Ironcrafter"]').length) {
          // Show model options menu
          $(".collection-sidebar__group--1572014535551").show();
          
          // Show model options
          $(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
          setTimeout(function(){ 
              $(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Ironcrafter']").parent().show();
          }, 750);   
        }
    }
  	if ( ~window.location.href.indexOf("iroquois") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Iro']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Iro']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("kingsland") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Kings']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Kings']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("knuth") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Knuth']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Knuth']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("megaworker") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Mega']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Mega']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("metal-muncher") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Metal Muncher']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Metal Muncher']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("metal-pro") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Metal Pro']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Metal Pro']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("midwest") ) {
    	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Midwest']").parent().addClass("tag--active");
      	
      
      	if ($('.collection-sidebar__group--1572014535551 .tag-list li a[title*="Midwest"]').length) {
          	// Show model options menu
        	$(".collection-sidebar__group--1572014535551").show();
      		
          	// Show model options
            $(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
            setTimeout(function(){ 
                $(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Midwest']").parent().show();
            }, 750);   
        }
    }
  	if ( ~window.location.href.indexOf("mubea") ) {
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Mubea']").parent().addClass("tag--active");
      
      	// Show model options
        if ($('.collection-sidebar__group--1572014535551 .tag-list li a[title*="Mubea"]').length) {
          // Show model options menu
          $('.collection-sidebar__group--1572014535551').show();

          // Show model options
          $(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
          setTimeout(function(){ 
            $('.collection-sidebar__group--1572014535551 .tag-list li a[title*="Mubea"]').parent().show();
          }, 750);  
        }  
    }  
  	if ( ~window.location.href.indexOf("nelson") ) {
    	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Nelson']").parent().addClass("tag--active");
      	
      	if ($('.collection-sidebar__group--1572014535551 .tag-list li a[title*="Nelson"]').length) {
            // Show model options menu
            $(".collection-sidebar__group--1572014535551").show();
          
          	// Show model options
            $(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
            setTimeout(function(){ 
              $(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Nelson']").parent().show();
            }, 750);          
        }
    }
  	if ( ~window.location.href.indexOf("nitto-kohki") ) {
    	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Nitto Kohki']").parent().addClass("tag--active");
      	
      	if ($('.collection-sidebar__group--1572014535551 .tag-list li a[title*="Nitto Kohki"]').length) {
            // Show model options menu
            $(".collection-sidebar__group--1572014535551").show();
          
          	// Show model options
            $(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
            setTimeout(function(){ 
              $(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Nitto Kohki']").parent().show();
            }, 750);          
        }
    }
  	if ( ~window.location.href.indexOf("ocean-machinery") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Ocean']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Ocean']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("omera") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Omera']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Omera']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("omes-promaco") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Omes/Promaco']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Omes/Promaco']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("peddinghaus") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Pedd']").parent().addClass("tag--active");
      	
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){ 
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Pedd']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("piranha") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Piranha']").parent().addClass("tag--active");
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){     
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Piranha']").parent().show();
        }, 750);   
    } 
  	if ( ~window.location.href.indexOf("pittsburgh") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Pittsburgh']").parent().addClass("tag--active");
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){     
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Pittsburgh']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("polmaco") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Polmaco']").parent().addClass("tag--active");
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){     
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Polmaco']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("scotchman") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Scot']").parent().addClass("tag--active");
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){     
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Scot']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("spartan") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Spartan']").parent().addClass("tag--active");
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){     
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Spartan']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("sunrise") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Sunrise']").parent().addClass("tag--active");
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){     
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Sunrise']").parent().show();
        }, 750);   
    }  
  	if ( ~window.location.href.indexOf("uni-hydro") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Uni-Hydro']").parent().addClass("tag--active");
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){     
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Uni-Hydro']").parent().show();
        }, 750);   
    }
    if ( ~window.location.href.indexOf("roper-whitney") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='R.W.']").parent().addClass("tag--active");
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){     
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='R.W.']").parent().show();
        }, 750);   
    }  
  	if ( ~window.location.href.indexOf("w-a-whitney") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Whitney']").parent().addClass("tag--active");
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){     
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Whitney']").parent().show();
        }, 750);   
    }
  	if ( ~window.location.href.indexOf("wysong") ) {
    	// Show model options menu
        $(".collection-sidebar__group--1572014535551").show();
       	// Activate checkbox for controlled automation (if loaded from menu)
       	$(".collection-sidebar__group--1572014497189 .tag-list li a[title*='Wysong']").parent().addClass("tag--active");
      
      	// Show model options
      	$(".collection-sidebar .collection-sidebar__group--1572014535551 .collapsible-trigger").trigger("click");
        setTimeout(function(){     
      		$(".collection-sidebar__group--1572014535551 .tag-list li a[title*='Wysong']").parent().show();
        }, 750);   
    }
	  
	  
	 
	// Clear model options if machine not selected
  	if (   !~window.location.href.indexOf("amada-marvel")
      	&& !~window.location.href.indexOf("baileigh")
        && !~window.location.href.indexOf("brobo")
        && !~window.location.href.indexOf("buffalo")
        && !~window.location.href.indexOf("cayman")
        && !~window.location.href.indexOf("clark")
        && !~window.location.href.indexOf("cleveland-steel-tool")
        && !~window.location.href.indexOf("controlled-automation")
        && !~window.location.href.indexOf("davco-bully")
        && !~window.location.href.indexOf("durma")
        && !~window.location.href.indexOf("edwards")
        && !~window.location.href.indexOf("enerpac")
        && !~window.location.href.indexOf("excel")
        && !~window.location.href.indexOf("fabmaster")
        && !~window.location.href.indexOf("falcon")
        && !~window.location.href.indexOf("ficep")
        && !~window.location.href.indexOf("franklin")
        && !~window.location.href.indexOf("gairu")
        && !~window.location.href.indexOf("geka")
        && !~window.location.href.indexOf("hawthorne")
        && !~window.location.href.indexOf("hendly-whittemore")
        && !~window.location.href.indexOf("hill-acme")
        && !~window.location.href.indexOf("hmi")
        && !~window.location.href.indexOf("ironcrafter")
        && !~window.location.href.indexOf("iroquois")
        && !~window.location.href.indexOf("kingsland")
        && !~window.location.href.indexOf("knuth")
        && !~window.location.href.indexOf("megaworker")
        && !~window.location.href.indexOf("metal-muncher")
        && !~window.location.href.indexOf("metal-pro")
        && !~window.location.href.indexOf("midwest")
        && !~window.location.href.indexOf("nelson")
        && !~window.location.href.indexOf("nitto-kohki")
        && !~window.location.href.indexOf("ocean-machinery")
        && !~window.location.href.indexOf("omera")
        && !~window.location.href.indexOf("omes-promaco")
        && !~window.location.href.indexOf("peddinghaus")
        && !~window.location.href.indexOf("piranha")
        && !~window.location.href.indexOf("pittsburg")
        && !~window.location.href.indexOf("polmaco")
        && !~window.location.href.indexOf("scotchman")
        && !~window.location.href.indexOf("spartan")
        && !~window.location.href.indexOf("sunrise")
        && !~window.location.href.indexOf("uni-hydro")
        && !~window.location.href.indexOf("w-a-whitney")
        && !~window.location.href.indexOf("wysong")
       ) {
     	$(".collection-sidebar__group--1572014535551 .tag-list li.tag--active a").trigger("click");
  	}
}

$(document).ready(function() {
  /* Smooth scroll anchor */
//   $('a[href*="#"]:not([href*="covid-19"])').on('click', function(evt) {
//     evt.preventDefault();
    
//     var targetOffset = $($(this).attr('href')).offset().top - $('.site-header-sticky').height();
//     /*targetOffset = targetOffset - 26;*/
    
//     $('html, body').animate(
//       { scrollTop: targetOffset - 60},
//       750
//     );
//   });
  
  /* Career accordions */
  $('.btn-accordion').click(function(e) {
      e.preventDefault();

      var $this = $(this);

      if ($this.parent().parent().siblings('.panel-collapse').hasClass('in')) {
          $this.parent().parent().siblings('.panel-collapse').removeClass('in');
          $this.parent().parent().siblings('.panel-collapse').slideUp(350);
          $this.find('.less').toggleClass('p-hide');
          $this.find('.less').removeClass('p-show');
          $this.find('.more').toggleClass('p-show');
          $this.find('.more').removeClass('p-hide');
      } else {
          $this.parent().parent().siblings('.panel-collapse').slideDown(350);
          $this.parent().parent().siblings('.panel-collapse').toggleClass('in');
          $this.find('.less').toggleClass('p-show');
          $this.find('.more').toggleClass('p-hide');
          $this.find('.more').removeClass('p-show');
          $this.find('.less').removeClass('p-hide');
          //$this.next().slideToggle(350);
      }
	});
  
  /* Hide Shopify Tooltip */
  $("div#shopify-section-1572097945585 .rte a").attr("title", "");
  
	/*** Store Filter ***/
 	/* Show Shape Options if Punch or Dies */
  	/*  . Triggered on URL bar containing keyword
    	. Triggered on click of filter bar list item
    	. Check Products filter to see if Punches or Dies is checked
	*/
  
  	if ( ~window.location.href.indexOf("collections") ) {
            // Check shape options menu
            updateShapeOptions();
      		
      		// Check model options menu
      		updateModelOptions();
    }
  
  	/* Phone Number field to Tag in /account/register page */
  	if ( ~window.location.href.indexOf("account/register") ) {
      var phoneField 	= $('input[name="customer-phone"]'),
          tagsField		= $('input[name="customer[tags]"]');
      
      phoneField.on('change input', function(e){
        var _self = $(this),
            number = _self.val().replace(/[^\d]/g, '');
        
        if (number.length == 10) {
      		number = number.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    	}
        
    	_self.val(number);
        _self.attr({ maxLength: 10, minLength: 10 });
        
        if (_self.val().length) {
          tagsField.val('Phone: ' + _self.val());
        } else {
          tagsField.val('');
        }
      });
    }
  
    /* Reorder button */
    $('.btn-reorder').on('click', function(e){
      e.preventDefault();

      var _self = $(this);
      var buttonText = _self.text();

      if (_self.data('reorder')) {
        var orderData = { items: eval('(' + _self.data('reorder') + ')') };

        _self.text('Reordering...').addClass('disabled').prop('disabled', true);

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: orderData,
          success: function(cart) {
            window.location.href = '/cart';
          },
          error: function(xhr, text) {
            alert('Could not add these order items to the cart at this time.');
          },
          complete: function(){
            _self.text(buttonText).removeClass('disabled').prop('disabled', false);
          }
        }); 
      }
    });
  
  	/* Contact link buttons */
  	moment.tz.add(['America/New_York|EST EDT|50 40|0101|1Lz50 1zb0 Op0']);
    var m = moment().tz("America/New_York");

    $('.contact-link').on('click', function(){
      if (m.day() >= 1 && m.day() <= 5 && m.hour() >= 7 && m.hour() <= 18) {
        SnapEngage.startLink();
        return false;
      }
    });

  /* Spanish Popup function */
  let country_code = 'US';
  // let countryArray = ['Mexico', 'Colombia', 'Spain', 'Argentina', 'Perú', 'Venezuela', 'Chile', 'Ecuador', 'Guatemala', 'Cuba', 'Bolivia', 'Dominican Republic', 'Honduras', 'Paraguay', 'El Salvador', 'Nicaragua', 'Costa Rica', 'Panama', 'Uruguay', 'Puerto Rico', 'Equatorial Guinea'];
  let countryArray = ['MX', 'CO', 'ES', 'AR', 'PE', 'VE', 'CL', 'EC', 'GT', 'CU', 'BO', 'DO', 'HN', 'PY', 'SV', 'NI', 'CR', 'PA', 'UY', 'PR', 'GQ'];
  $.getJSON('https://json.geoiplookup.io/?callback=?', function(data) {
    country_code = data['country_code'];
  });

  setTimeout(function() {
    console.log('You are in ' + country_code + ' now!');
    // if ( country_code == 'MX' ) { 
    if ( $.inArray(country_code, countryArray) != -1 ) {      
      $('#spanish_modal').addClass('active');
    }
  }, 3000);

  $('.cus_modal_overlay, .cus_modal_close').on('click', function(){
    $('#spanish_modal').removeClass('active');
  });

  $('.punch_die_modal_overlay, .punch_die_modal_close').on('click', function(){
    $('#punch_die_modal').removeClass('active');
  });


  /* FAQ toggle function */
  $('.faq_action').on('click', function() {
    
    if ( $(this).closest('.faq_block').hasClass('opened') ) {

      $(this).closest('.faq_block').removeClass('opened');
      $(this).find('span').text('More');
      $(this).closest('.faq_block').find('.faq_content').slideUp(350, function() {
        
      });
      
    } else {

      $(this).closest('.faq_block').addClass('opened');
      $(this).find('span').text('Less');
      $(this).closest('.faq_block').find('.faq_content').slideDown(350, function() {
        
      });
      
    }
      
  });

  /* FAQ image modal function */
  $('.faq_img img').on('click', function() {

    let img = $(this).data('img');
    $('.img_modal_content img').attr('src', img);
    $('.img_modal').addClass('active');
    
  });

  $('.img_modal_overlay, .img_modal_content span').on('click', function() {

    $('.img_modal').removeClass('active');
    let placeholder = $('.img_modal_content img').data('origin');
    setTimeout(function(){
      $('.img_modal_content img').attr('src', placeholder);
    }, 250);    
    
  });


  /* Custom script for Punch & Die popup */
  getInitialCartState().then(initialCartState => {
    // Set the initial number of items
    window.previousItemCount = initialCartState.item_count;
    console.log(window.previousItemCount);

    var previousActiveState = $('.icart-slider-drawer.icart_popup').hasClass('active');
    var intervalId;
    var startTime;
    var cartUpdated = false;
    var cusCartItems = [];
    var notIncludeList = ['f55-corner-radius-die', 'f59-corner-radius-die', 'f62-corner-radius-die', 'f16-corner-radius-punch-no-keyway', 'f16-corner-radius-punch-with-v-groove', 'f16-corner-radius-punch-with-1-4-x-1-8-cross-keyway', 'f16-corner-radius-punch-with-4mm-cross-keyway', 'f20-corner-radius-punch-no-keyway', 'f20-corner-radius-punch-with-1-4-x-1-8-cross-keyway', 'f20-corner-radius-punch-with-6mm-cross-keyway', 'f26-corner-radius-punch-no-keyway', 'f26-corner-radius-punch-with-v-groove', 'f26-corner-radius-punch-with-1-4-x1-8-cross-keyway'];

    // Function to check for cart updates
    function checkCartUpdates() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Compare the current number of items in the cart with the previous state
          if (cart.item_count !== window.previousItemCount) {
            var specialTagPunch = '"Punches"';
            var specialTagDie = '"Dies"';
            // Cart has been updated
            console.log('Cart updated!');
            // Perform actions or update UI as needed
            cusCartItems = cart.items;
            var size = $('form.product-single__form select[data-index="option1"]').val();
            var p_handle = $('.product-section').data('product-handle');
            var tags = $('.product-section').data('tags');
            var tagsArray = tags.split(' ');
            var isSpecialTagPunchPresent = tagsArray.includes(specialTagPunch);
            var isSpecialTagDiePresent = tagsArray.includes(specialTagDie);

            if ( !notIncludeList.includes(p_handle) && isSpecialTagPunchPresent ) {
              cusCartItems.forEach(item => {
                let cusItemHandle = item.handle;
                if ( !notIncludeList.includes(cusItemHandle) ) {
                  fetch(`/products/${cusItemHandle}.json`)
                    .then(response => response.json())
                    .then(data => {
                      let cusItem = data.product;
                      let cusItemTags = cusItem.tags.split(',').map(tag => tag.trim());
                      if ( cusItemTags.includes('Dies') && !cusItemTags.includes('Punches') ) {
                        if ( size == item.variant_options[0] ) {
                          setTimeout(function() {
                            jQuery('#punch_die_modal').addClass('active');
                          }, 50);
                        }
                      }
                    })
                    .catch(error => {
                      console.error(error);
                    });
                }
              });
            }

            if ( !notIncludeList.includes(p_handle) && isSpecialTagDiePresent ) {
              cusCartItems.forEach(item => {
                let cusItemHandle = item.handle;
                if ( !notIncludeList.includes(cusItemHandle) ) {
                  fetch(`/products/${cusItemHandle}.json`)
                    .then(response => response.json())
                    .then(data => {
                      let cusItem = data.product;
                      let cusItemTags = cusItem.tags.split(',').map(tag => tag.trim());
                      if ( cusItemTags.includes('Punches') && !cusItemTags.includes('Dies') ) {
                        if ( size == item.variant_options[0] ) {
                          setTimeout(function() {
                            jQuery('#punch_die_modal').addClass('active');
                          }, 50);
                        }
                      }
                    })
                    .catch(error => {
                      console.error(error);
                    });
                }
              });
            }
    
            // Update the previous number of items
            window.previousItemCount = cart.item_count;

            // Set the flag to true
            cartUpdated = true;
          }
        })
        .catch(error => {
          console.error('Error checking cart updates:', error);
        });
    }

    // Use MutationObserver to watch for changes in the DOM (assuming class changes)
    var observer = new MutationObserver(function (mutationsList) {
      for (var mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // Check if the specific element has the 'active' class
          var currentActiveState = $('.icart-slider-drawer.icart_popup').hasClass('active');
          if (currentActiveState && !previousActiveState) {
            console.log('The element is now active.');
            // Set the start time for the interval
            startTime = Date.now();
            // Clear any existing interval
            clearInterval(intervalId);
            // Reset the flag
            cartUpdated = false;
            // Set up a new interval to check for updates
            intervalId = setInterval(function () {
              checkCartUpdates();

              // Check if the interval has run for a certain duration (1000ms in this example)
              if (Date.now() - startTime >= 1200 || cartUpdated) {
                clearInterval(intervalId);
              }
            }, 100);            
          }

          // Update the previous state of 'active' class
          previousActiveState = currentActiveState;
        }
      }
    });

    // Target the element you want to observe
    var targetNode = document.querySelector('.icart');

    // Options for the observer (you can adjust them as needed)
    var observerConfig = { attributes: true, subtree: true };

    if (targetNode) {
      // Start observing the target element
      observer.observe(targetNode, observerConfig);
    }
    
  });
  
});

// Function to get the initial cart state
function getInitialCartState() {
  return fetch('/cart.js')
    .then(response => response.json())
    .catch(error => {
      console.error('Error fetching initial cart state:', error);
    });
}


/*** FORM UPLOAD FIELD ***/
/* Modified to handle two form upload fields on the same page */
(function() {
 var selector = '.custom-form-wrapper .form-field-wrapper .cf-btn-file + span';
  setTimeout(function(){
    $(selector).each(function() {
      var observer = new (window.MutationObserver || window.WebKitMutationObserver)(function(mutations) {
        mutations.forEach(function(mutation) {
          var text = mutation.target.textContent;
          if (text.indexOf('Uploaded ') === 0) {
            mutation.target.textContent = 'File Uploaded';
          }
        });
      });
      observer.observe(this, { childList: true, characterData: true, attributes: true, subtree: true });
    });
  }, 800);
})();



/*** P&D SET DROPDOWN FIELD  ***/
// DISABLED AND REPLACED WITH BUY NOW BUTTONS
/*
(function() {
  setTimeout(function(){
    $('.custom-form-wrapper form[name="form67f46f44944344bcb4f32c59a53cbc94"] .form-field-wrapper select.form-control').change(function(e){
      e.preventDefault();
      var data= $(this).val();
    });
    
    $('.slide-content .btn').on('click touch', function(e) {
      e.preventDefault();
      var set = $(this).attr('name');
      var selection = '.custom-form-wrapper form[name="form67f46f44944344bcb4f32c59a53cbc94"] .form-field-wrapper select.form-control option[value="' + set + '"]';
	  //$('.custom-form-wrapper form[name="form67f46f44944344bcb4f32c59a53cbc94"] .form-field-wrapper select.form-control').val(set).trigger('change');
      window.acerillCustomFormsEventBus.publish({ eventType: 'UPDATE_VALUE_COMMAND', fieldPredicate: { label: 'Select a Set' }, value: set });
    });
  }, 800);
})();

*/